import { ActionType, FrameStencil, Marker, MarkerType, StencilType } from "../../types";
import { getBallActions } from "./frame-stencil-filters";

export interface ClearMarkerProps {
  marker: Marker;
  stencils: FrameStencil[];
}

export const clearMarker = ({
  marker,
  stencils,
}: ClearMarkerProps): {
  clearedStencils: FrameStencil[];
  clearedMarker: Marker;
} => {
  const stencilsWithoutMarker = stencils.filter((stencil) => stencil.id !== marker.id);

  const ballActionsWithPlayer =
    marker.markerType === MarkerType.PLAYER
      ? getBallActions(stencilsWithoutMarker)
          .filter((pass) => pass.nextPlayer === marker.id || pass.prevPlayer === marker.id)
          .map((ball) => ball.id)
      : [];

  const clearedStencils = stencilsWithoutMarker.map((s): FrameStencil => {
    if (
      s.stencilType === StencilType.ACTION &&
      s.actionType === ActionType.BALL &&
      ballActionsWithPlayer.includes(s.id)
    ) {
      if (s.nextPlayer === marker.id) return { ...s, nextPlayer: null };
      else if (s.prevPlayer === marker.id) return { ...s, prevPlayer: null };
      else return s;
    } else return s;
  });

  const clearedMarker: Marker =
    marker.markerType === MarkerType.PLAYER || marker.markerType === MarkerType.BALL
      ? { ...marker, movements: [] }
      : marker;

  return { clearedMarker, clearedStencils };
};
